export default "__VITE_ASSET__rbIRE4QL__"